<template>
  <div>
    <div class="header-wrapper pb-3">
      <button class='btn btn-light' @click="uploadImage">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
        </svg>
        Vertaling uploaden
      </button>
    </div>
    <input v-if="showFile" ref="input" type="file" id="placeholder-input" accept="image/*" style="display: none" @change="change">
    
    <div
      class="grid-wrapper d-flex justify-content-center align-items-center"
      :class="{
        loading,
        'empty-list': !loading && !images.length,
      }"

      id="grid-wrapper"
    >
      <transition name="fade-trans" mode='out-in'>
        <div v-if="loading" class="images-list pt-3" key="loading">
          <ImageItem v-for="(file, i) in placeholders" :key="file + i"
            :type="file"
            :forced-ske="true"
          />
        </div>
        <ImageGallery v-else-if="!loading && images.length" key="content"
          class="images-list pt-3"
          img-tag-selector=".image-item-img"
          :class="{onlyTwo: images.length <= 2}"

          v-model="mainImageIndex"
          :images="imageUrls"

          id="images-list"
        >
          <ImageItem v-for="(file, index) in images" :key="file.fid"
            v-bind="file"
            :options="options"
  
            @remove="removeFile(file)"
            @show-modal="mainImageIndex = index"
            @save-new-type="saveNewType"
          />
        </ImageGallery>
        <EmptyStatePlaceholder v-else-if="!images.length" key="empty-staet"
          :title="emptyStateTitle"
          :description="emptyStateDescription"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </EmptyStatePlaceholder>
      </transition>
    </div>

    <FileUploadDropzone @upload="upload"/>
  </div>
</template>

<script>

import EmptyStatePlaceholder from "../EmptyStatePlaceholder.vue"
import ImageItem from "./ImageItem.vue"
import FileUploadDropzone from "../FileUploadDropzone.vue"
import ImageGallery from "../Modals/ImageGallery.vue"

export default {
  mixins: [FileUploadDropzone],
  components: {
    ImageGallery,
    EmptyStatePlaceholder,
    ImageItem,
    FileUploadDropzone
  },
  props: {
    emptyStateTitle: {
      type: String,
      required: true,
    },
    emptyStateDescription: {
      type: String,
      required: false,
    },
    endpoint: {
      type: String,
      required: true,
    },

    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      mainImageIndex: null,
      images: [],

      loading: true,
      showFile: true,
      placeholders: [
        "thumbnail",
        "thumbnail",
        "thumbnail",
        "thumbnail",
        "thumbnail",
        "thumbnail",
      ],
    }
  },
  async created() {
    await this.loadImages()
  },
  methods: {
    upload(files) {
      this.openModal(files[0])
    },
    uploadImage() {
      this.$refs.input.click()
    },
    async saveNewType({ type, fid }) {
      await this.$handlePromise(
        (async () => {
          await this.axios.put(this.endpoint + "/" + fid, { type })
          await this.loadImages()
        })
      )
    },
    async removeFile(file) {
      await this.$handlePromise(
        (async () => {
          await this.axios.delete(this.endpoint + "/" + file.fid)
          await this.loadImages()

          this.$success("Afbeelding verwijderd!")
        })()
      )
    },
    async change() {
      const file = this.$refs.input.files[0]
      if (!file) return;
      this.openModal(file)
    },
    openModal(file) {
      this.$pushModal({
        modal: "AddImageType",
        toBind: {
          options: this.options,
          file,
          callback: async type => {
            await this.$handlePromise(
              (async () => {
                const payload = new FormData()
                payload.append("filename", file)
                payload.append("type", type)

                await this.$handlePromise(
                  this.axios.post(this.endpoint, payload, {
                    headers: {
                      "Content-Type": "multipart/form-data"
                    }
                  })
                )
                await this.loadImages()

                this.$success("Nieuwe afbeelding toegevoegd")
              })()
            ) 

            this.showFile = false
            this.$nextTick(() => this.showFile = true)
          },
        },
      })
    },
    async loadImages() {
      this.loading = true
      this.images = (await this.axios.get(this.endpoint, { params: {page_size: 50} })).data.results
      this.loading = false
    },
  },
  computed: {
    imageUrls() {
      return this.images.map(item => item.url)
    },
  },
}

</script>

<style scoped>

.grid-wrapper, .images-list {
  min-height: 450px;
}

.images-list {
  width: 100%;
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(265px, 1fr));
  align-items: start;
}

@media (min-width: 769px) {
  .onlyTwo {
    grid-template-columns: repeat(auto-fit, minmax(265px, 250px));
  }
}


.header-wrapper {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

</style>
